
const BASE_URL = ENV_DEV ? "https://api.t.quanmaikeji.com/user/v1/oauth/wx?url=" : "https://api.quanmaikeji.com/user/v1/oauth/wx?url=";
const YZL_URL = ENV_DEV ? "https://api.t.quanmaikeji.com/user/v1/oauth/yzl?url=" : "https://api.quanmaikeji.com/user/v1/oauth/yzl?url=";
export default {
    BASE_URL,
    YZL_URL
}
//token 临时票据


//////////////////
// WEBPACK FOOTER
// ./config/params.js
// module id = null
// module chunks = 